export default __webpack_public_path__ + "static/joinThousandsOfStudents-c218b43d976f053c5958ab78433ca225.png";